const s = {
  inline: !0,
  attrs: {
    attributePath: { default: "" },
    fallback: { default: "" }
  },
  group: "inline",
  selectable: !0,
  parseDOM: [
    {
      tag: "span.embercom-prosemirror-composer-template",
      getAttrs(e) {
        return {
          attributePath: e.getAttribute("data-template-identifier"),
          fallback: e.getAttribute("data-template-fallback")
        };
      }
    }
  ],
  toDOM(e) {
    let a = e.attrs.attributePath, r = e.attrs.fallback, t = e.type.spec.infoResolver, i = t == null ? void 0 : t.humanReadable(a), l = ["embercom-prosemirror-composer-template", "intercom-interblocks-template"];
    return t && !t.isValid(a) && l.push("invalid"), t && t.requiresFallback(a, r) && l.push("requires-fallback"), [
      "span",
      {
        class: l.join(" "),
        "data-template-identifier": a,
        "data-template-fallback": r
      },
      i
    ];
  }
};
export {
  s as templateSpec
};
